import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';


function ForgotPassword() {

    return (
        <>
       <main className="login forgot">
      <div className="login-left">
        <div className="login-left-inner">
          <div className="logi-logo">
            <img src="/images/logo.svg" alt="logo" />
          </div>

          <div className="login-mid">
            <h3>Forgot Password?</h3>
            <p>Enter your registered email address to reset your password.</p>

            <form>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Email</label>
                <input
                  type="email"
                  className="form-control"
                  id="exampleInputEmail1"
                  placeholder="admin@resumate.com"
                  aria-describedby="emailHelp"
                />
              </div>

              <button type="submit" className="btn">Send Reset Link</button>
            </form>
          </div>

          <h4>
            <a href=""><Link to="/admin/login">Back to Login</Link></a>
          </h4>
        </div>
      </div>

      <div className="login-left right">
        <img src="/images/login-bg.png" className="img-fluid" alt="Login Background" />
      </div>
    </main>

        </>
    );
}

export default ForgotPassword;